"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.wwSubNavButtons = exports.wwLinks = exports.tkSubNavButtons = exports.buildWWIconLinks = exports.buildTKIconLinks = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));
const tkSubNavButtons = exports.tkSubNavButtons = [{
  title: 'Free Samples',
  onClick: () => window.location.assign(`/paper/free-samples`)
}];
const wwSubNavButtons = exports.wwSubNavButtons = [{
  title: 'Free Samples',
  onClick: () => window.location.assign(`/wedding-paper/page/free-wedding-invitation-samples`)
}];
const buildTKIconLinks = (isUserLoggedIn, cartCount, draftCount) => {
  const links = [];
  if (isUserLoggedIn) {
    links.push({
      iconName: 'truck',
      text: 'Your Orders',
      href: '/paper/your-orders',
      ariaLabel: 'Your Orders'
    });
  }
  return (0, _concat.default)(links).call(links, [{
    iconName: 'bookmark',
    href: '/paper/your-drafts',
    ariaLabel: 'Your Drafts',
    badgeValue: draftCount
  }, {
    iconName: 'cart',
    href: '/paper/cart',
    ariaLabel: 'Your Cart',
    badgeValue: cartCount
  }]);
};
exports.buildTKIconLinks = buildTKIconLinks;
const buildWWIconLinks = (isUserLoggedIn, cartCount) => {
  const links = [];
  if (isUserLoggedIn) {
    links.push({
      iconName: 'truck',
      text: 'Your Orders',
      href: '/wedding-paper/your-orders',
      ariaLabel: 'Your Orders'
    });
  }
  return (0, _concat.default)(links).call(links, [{
    iconName: 'cart',
    href: '/wedding-paper/cart',
    ariaLabel: 'Your Cart',
    badgeValue: cartCount
  }]);
};
exports.buildWWIconLinks = buildWWIconLinks;
const wwLinks = exports.wwLinks = [{
  text: 'Save the Dates',
  href: '/wedding-paper/save-the-dates',
  links: [{
    text: 'Save the Date Cards',
    href: '/wedding-paper/save-the-date-cards'
  }, {
    text: 'Save the Date Postcards',
    href: '/wedding-paper/save-the-date-postcards'
  }]
}, {
  text: 'Invitations',
  href: '/wedding-paper/invitations',
  links: [{
    text: 'Wedding Invitations',
    href: '/wedding-paper/wedding-invitations'
  }, {
    text: 'Enclosure Cards',
    href: '/wedding-paper/wedding-enclosure-cards'
  }, {
    text: 'RSVP Cards',
    href: '/wedding-paper/wedding-rsvp-cards'
  }, {
    text: 'Envelope Liners',
    href: '/wedding-paper/wedding-envelope-liners'
  }, {
    text: 'Bridal Shower',
    href: '/wedding-paper/bridal-shower-invitations'
  }, {
    text: 'Rehearsal Dinner',
    href: '/wedding-paper/rehearsal-dinner-invitations'
  }]
}, {
  text: 'Ceremony & Reception',
  href: '/wedding-paper/ceremony-reception',
  links: [{
    text: 'Programs',
    href: '/wedding-paper/wedding-programs'
  }, {
    text: 'Place Cards',
    href: '/wedding-paper/wedding-place-cards'
  }, {
    text: 'Guest Books',
    href: '/wedding-paper/wedding-guest-books'
  }, {
    text: 'Menus',
    href: '/wedding-paper/wedding-menus'
  }, {
    text: 'Stickers',
    href: '/wedding-paper/wedding-stickers'
  }, {
    text: 'Table Numbers',
    href: '/wedding-paper/wedding-table-numbers'
  }, {
    text: 'Gift Tags',
    href: '/wedding-paper/wedding-gift-tags'
  }]
}, {
  text: 'Thank Yous',
  href: '/wedding-paper/thank-yous',
  links: [{
    text: 'Thank You Cards',
    href: '/wedding-paper/thank-you-cards'
  }, {
    text: 'Thank You Postcards',
    href: '/wedding-paper/thank-you-postcards'
  }]
}];